import { useEffect, useMemo, useState } from 'react';
import { Service } from './service'; // ajusta el path si difiere
import useDynamicFavicon from '../hooks/useDynamicFavicon';
import { Enviroment } from '../_config/constants/enviroment-v2.constant';

export default function FaviconProvider({ children }) {
  const [modules, setModules] = useState([]);

  useEffect(() => {
    new Service()
      .getModulesByTemplate('home', 'ecommerce', Enviroment.ROOT_PHARMACY)
      .then((res) => setModules(res?.data || []))
      .catch((err) => console.error('Error cargando módulos:', err));
  }, []);

  const iconUrl = useMemo(
    () => modules.find((m) => m.location === 'icon-and-favicon')?.image,
    [modules]
  );

  useDynamicFavicon(iconUrl ? iconUrl : 'https://storage.googleapis.com/tirx-resources-develop/817f55db-81a6-46a4-affd-ac46d05deaa0.png', { persist: true, apple: true });

  return children;
}
